export type SubscriptionTable = {
	id: string
	idx: number
	name: string
	offer_text: string
	trial_text: string
	active: boolean
	monthly_flag_text: string
	monthly_flag_bgcolor: string
	yearly_flag_text: string
	yearly_flag_bgcolor: string
}

export type SubscriptionPlan = {
	plan_key: PlanKey
	idx: number
	name_visible: string
}

export type SubscriptionTablePlan = {
	id: string
	sub_table_id: string
	sub_plan_key: PlanKey
	idx: number
	stripe_product_id: string
	active: boolean
}

export type SubscriptionStripeCoupon = {
	amount_off: number
	applies_to: null
	created: number
	currency: string
	currency_options: null
	deleted: boolean
	duration: string
	duration_in_months: number
	id: string
	livemode: boolean
	max_redemptions: number
	metadata: string
	name: string
	object: string
	percent_off: number
	redeem_by: number
	times_redeemed: number
	valid: boolean
}

export type SubscriptionProduct = {
	id: string
	name: string
	description: string
}

export type SubscriptionPrice = {
	id: string
	stripe_product_id: string
	unit_amount: string
	currency: string
	recurring_interval: RecurringInterval
	stripe_coupon_id: string
	coupon_top_label: string
	coupon_top_label_bgcolor: string
	coupon_text_primary: string
	coupon_text_comment: string
	default_top_label: string
	default_top_label_bgcolor: string
	default_text_primary: string
	default_text_comment: string
	active: boolean
}

export type SubscriptionFeature = {
	id: string
	idx: number
	name_internal: string
	name_visible: string
	api_url: string
	params: string
}

export type SubscriptionPlanFeature = {
	id: string
	plan_key: PlanKey
	feature_id: string
	idx: number
	enabled: boolean
	visible: boolean
	feature_format: string
	feature_color: string
}

export type SubscriptionAccountPlanFeature = {
	id: string
	name_internal: string
	api_url: string
	params: string
}

export const enum RecurringInterval {
	Month = 'month',
	Year = 'year'
}

export const enum PlanKey {
	Trial = '',
	Basic = 'basic',
	Pro = 'pro',
	Advanced = 'advanced'
}

// //'enum like' object declaration (notice the `as const` at the end)
// export const PlanKey = {
//     Trial: "",
//     Basic: "basic",
//     Pro: "pro",
//     Advanced: "advanced"
// } as const;

// //'enum like' "TS type" creation
// export type PlanKeyType = keyof typeof PlanKey;
